import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminAnalytics from './pages/AdminAnalytics';
import AdminLogin from './pages/AdminLogin';
import AdminSettings from './pages/AdminSettings';
import AdminDashboard from './pages/AdminDashboard';
import AdminExpertRequests from './pages/AdminExpertRequests';
import AdminChats from './pages/AdminChats';
import AdminTransactions from './pages/AdminTransactions';
import AdminUsers from './pages/AdminUsers';

function App() {
  return (
    <Routes>
       <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/chats" element={<AdminChats />} />
        <Route path="/admin/expert-requests" element={<AdminExpertRequests />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/analytics" element={<AdminAnalytics />} />
        <Route path="/admin/transactions" element={<AdminTransactions />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="*" element={<AdminDashboard />} />
    </Routes>
  );
}

export default App;